export function createUploadWidget(handler) {
  const options = {
    cloudName: process.env.CLOUDINARY_CLOUD_NAME,
    uploadPreset: process.env.CLOUDINARY_UPLOAD_PRESET
  }
  return cloudinary.createUploadWidget(options, handler)
}
